import { RefObject, useEffect, useState } from "react"
import { PlaybackSettings, PlaybackSpeedType } from "../consts"

export default function usePlaybackRate(
  elementRef: RefObject<HTMLVideoElement | HTMLAudioElement | null>
) {
  const [selectedPlaybackSpeed, setPlaybackSpeed] =
    useState<PlaybackSpeedType>("NORMAL")
  useEffect(() => {
    if (!elementRef || !elementRef.current) return
    const newPlaybackValue = PlaybackSettings.find(
      (item) => item.type === selectedPlaybackSpeed
    )?.value
    if (newPlaybackValue) elementRef.current.playbackRate = newPlaybackValue
  }, [elementRef, selectedPlaybackSpeed])

  return [selectedPlaybackSpeed, setPlaybackSpeed] as const
}
